import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";

type Props = {
  classes: Object,
  className: string,
  post: Object,
  site: Object,
};

const BlogAbout = ({ classes, className, post, site }: Props) => {
  // Hide the entire section if we are missing author or bio information
  if (!(post && post.author && site && site.aboutBio)) {
    return null;
  }

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.aboutContainer}>
        <Typography type="heading5" className={classes.aboutHeading}>
          About the Author
        </Typography>
        <div className={classes.aboutMain}>
          {post.author.picture && (
            <img
              className={classes.aboutMainPhoto}
              src={post.author.picture}
              alt="Author"
            />
          )}
          <div className={classes.aboutMainRight}>
            <Typography type="heading4" className={classes.aboutMainName}>
              {post.author.fullName}
            </Typography>
            <div
              className={classes.aboutMainDesc}
              dangerouslySetInnerHTML={{
                __html: site.homepageBio,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withStyles((theme) => ({
  "@global body": {
    backgroundColor: "#fff !important",
    a: {
      textDecoration: "none",
      "&:hover": {
        textDecoration: "none !important",
      },
    },
  },
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: theme.spacing.unit * 4,
    background: "#fff", // material-design 1dp

    [theme.breakpoints(600)]: {
      maxWidth: "584px",
    },

    [theme.breakpoints(900)]: {
      maxWidth: "700px",
    },
  },

  aboutContainer: {
    padding: "0px 20px",
  },

  aboutHeading: {
    paddingBottom: theme.spacing.unit,
    textAlign: "center",
  },

  aboutMain: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
  },

  aboutMainName: {
    paddingBottom: theme.spacing.unit * 0.5,
    textAlign: "center",
    paddingTop: theme.spacing.unit,
  },

  aboutMainPhoto: {
    maxWidth: "180px",
    maxHeight: "180px",
    minHeight: "180px",
    marginTop: theme.spacing.unit * 0.75,
    objectFit: "contain",
  },

  [theme.breakpoints(600)]: {
    aboutContainer: {
      borderBottom: theme.borders["default"],
      padding: "0px",
    },

    aboutHeading: {
      borderBottom: theme.borders["default"],
      textAlign: "left",
    },
    aboutMain: {
      padding: "40px 0 80px 0",
      justifyContent: "flex-start",
      flexWrap: "nowrap",
    },
    aboutMainName: {
      paddingTop: "0px",
      textAlign: "left",
    },
    aboutMainPhoto: {
      paddingRight: theme.spacing.unit * 1.5,
      marginTop: "0px",
    },
    aboutMainRight: {
      display: "flex",
      flexDirection: "column",
    },
    aboutMainDesc: {
      color: "#121130",
      fontSize: "16px",
      lineHeight: "28px",
      letterSpacing: ".44px",
    },
  },
}))(BlogAbout);
